import { TableRow, TableCell, Skeleton } from "@mui/material";
import { useSelector } from "react-redux";
import "./SummaryRow.scss";
interface SummaryRowProps {
    label: string;
    value: string;
    colSpan?: any;
    bgColor?: string;
}

const SummaryRow = ({ label, value, bgColor }: SummaryRowProps) => {
    const isLoading = useSelector((state: any) => state.loading.isLoading);

    return (
        <TableRow sx={bgColor ? { background: bgColor } : undefined}>
            <TableCell className="table-cell" sx={{ fontSize: "0.75vw", display: "flex", justifyContent: "space-between", borderTop: "none", borderLeft: "none", borderRight: "none", }}>
                <span className="table-cell-text leading-[1.5] text-black bg-none">
                    {label}
                </span>
                {isLoading ? (
                    <Skeleton
                        variant="text"
                        sx={{ fontSize: "0.8vw", width: "20%" }}
                    />
                ) : (
                    <span className="table-cell-text leading-[1.5] text-black bg-none w-[18%] text-center">
                        {value}
                    </span>
                )}
            </TableCell>
        </TableRow>
    );
};

export default SummaryRow;